import { ItemMessageBase } from 'src/app/shared/models/itemmessagebase.model';

export class InputContract extends ItemMessageBase {
  id: number;
  contractedAmountValue = 0;
  measuredValue = 0;
  percentageValueMeasuredUnderContracted = 0;
  contractedAmountQuantity = 0;
  measuredQuantity = 0;
  percentageQuantityMeasuredUnderContracted = 0;
  quantityReleased = 0;
  percentageQuantityReleasedUnderMeasured = 0;
  valueReleased = 0;
  percentageValueReleasedUnderMeasured = 0;
}
